module.exports = __webpack_public_path__ + "fonts/ticonfont.e1ee9e17.ttf";